"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderByPipe = void 0;
class OrderByPipe {
    transform(records, args) {
        return records.sort(function (a, b) {
            let aproperty = a[args.property];
            let bproperty = b[args.property];
            if (args.property === 'subscriberBusinessName') {
                if (!aproperty) {
                    if (!bproperty) {
                        bproperty = b['firstname'];
                        aproperty = a['firstname'];
                    }
                    aproperty = a['firstname'];
                }
                else if (!bproperty) {
                    bproperty = b['firstname'];
                }
            }
            else if (args.property === 'deviceName') {
                if (!aproperty) {
                    if (!bproperty) {
                        bproperty = b['displayName'];
                        aproperty = a['displayName'];
                    }
                    aproperty = a['displayName'];
                }
                else if (!bproperty) {
                    bproperty = b['displayName'];
                }
                else {
                    aproperty = aproperty + a['displayName'];
                    bproperty = bproperty + b['displayName'];
                }
            }
            if (args.property !== 'startCal' && args.property !== 'endCal') {
                if (aproperty) {
                    aproperty = aproperty.trim();
                }
                if (bproperty) {
                    bproperty = bproperty.trim();
                }
            }
            if (aproperty < bproperty) {
                return -1 * args.direction;
            }
            else if (aproperty > bproperty) {
                return 1 * args.direction;
            }
            else {
                return 0;
            }
        });
    }
}
exports.OrderByPipe = OrderByPipe;
//# sourceMappingURL=orderBy.pipe.js.map